import React from 'react';

import { DoubleArrow } from '@material-ui/icons';

//utils
import callApi from '../../utils/callApi';
import { MONTHS } from '../../constants/dateConstants';

//constants
import {
    FETCH_VIDEO_SEGMENT_BY_ID,
    FETCH_VIDEO_VINTAGE_BY_ID,
    FETCH_VIDEO_AUDITION_PREVIEW_BY_ID
} from '../../constants/apiUrls/apiUrls';

import '../../css/player.css';

const text = {
    unlock: 'Unlock this segment',
    onlyMembers: 'Only Naked News members can watch this',
    clickHere: 'Click here to get access'
};

class LockedVideo extends React.Component {
    
    state = {
        program: null
    };

    decideUrl = () => {
        const { videoElement, typeOfListing } = this.props;
        if (typeof videoElement !== 'undefined') {
            switch (typeOfListing) {
                case 'all':
                    return FETCH_VIDEO_SEGMENT_BY_ID.replace(
                        '{id}',
                        videoElement.programSegmentId
                    );
                case 'audition':
                    return FETCH_VIDEO_AUDITION_PREVIEW_BY_ID.replace(
                        '{id}',
                        videoElement.auditionId
                    );
                case 'vintage':
                    return FETCH_VIDEO_VINTAGE_BY_ID.replace(
                        '{id}',
                        videoElement.id
                    );
                default:
                    return FETCH_VIDEO_SEGMENT_BY_ID.replace(
                        '{id}',
                        videoElement.programSegmentId
                    );
            }
        }
    };

    fetchMainProgram = url => {
        callApi(url, 'get', {}).then(res => {
            const program = res.data;
            this.setState({ program });
        });
    };

    componentDidMount() {
        if (!this.props.videoElement.bannerImage && !this.props.videoElement.imageUrl)
            this.fetchMainProgram(this.decideUrl());
    }

    getMonthName = num => {
        let mNum = ++num;
        mNum < 10 ? (mNum = '0' + mNum) : (mNum = '' + mNum);
        let month = MONTHS.find(m => m.number === mNum);
        return month && month.name;
    };

    render() {
        const {
            videoElement,
            typeOfListing,
            customBackgroundColor,
            slug
        } = this.props;
        const { program } = this.state;
        const imgUrl = program && program.clip && program.clip.imageUrl;
        const imageUrl = videoElement.imageUrl;
        const anchors =
            program &&
            program.anchors &&
            program.anchors.map(anc => anc.name).join(', ');
        const segName = program && program.segment && program.segment.name;
        let title = '';
        if (typeOfListing === 'audition') {
            if (program && program.date) {
                let date = new Date(program.date);
                title = `${this.getMonthName(
                    date.getMonth()
                )} ${date.getDate()}, ${date.getFullYear()}`;
            } else {
                let date = new Date(videoElement.date);
                title = `${this.getMonthName(
                    date.getMonth()
                )} ${date.getDate()}, ${date.getFullYear()}`;
            }
        } else if (videoElement.title) {
            title = videoElement.title;
        } else if (videoElement.name) {
            title = videoElement.name;
        } else if (program) {
            if (program.segment) {
                title = `${anchors} in ${segName}`;
            } else if (program.name) {
                title = program.name;
            }
        }

        return (
            <div
                className="masthead"
                style={{
                    backgroundColor: customBackgroundColor ? customBackgroundColor : '#252525'
                }}>
                <div className="container">
                    <div
                        id="video-player-container"
                        className="clearfix video-player-container locked"
                    >
                        <div className="locked-player">
                            <div className="clearfix">
                                <div className="player-zone">
                                    <a
                                        className="video video-player"
                                        style={{ display: 'block' }}
                                        href="/account/purchase"
                                    >
                                        <img
                                            className="img-responsive"
                                            src={
                                                videoElement.bannerImage ||
                                                imgUrl ||
                                                imageUrl ||
                                                (program && program.bannerImage)
                                            }
                                        />
                                        <div className="blackout-container">
                                            <div className="blackout">
                                                <div className="blackout-title">
                                                    {text.unlock}
                                                </div>
                                                <div className="blackout-text">
                                                    {text.onlyMembers}
                                                </div>
                                                <div className="blackout-button btn btn-lg btn-primary">
                                                    {text.clickHere}
                                                    <div className="icons-group">
                                                        <DoubleArrow fontSize="inherit" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                    <div className="player-info">
                                        <div className="player-title">
                                            <div className="player-title-name">
                                                <div className="player-title-date">
                                                    {slug ? slug : title}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default LockedVideo;
